/**
 * Heatmap das tabelas numéricas do chat (tabelas markdown e artifacts de mapa):
 * a cor vai do verde (menor valor da tabela) ao vermelho (maior).
 */
export function heatmapCellStyle(value: number, min: number, max: number): string {
  const t = max > min ? (value - min) / (max - min) : 0;
  const hue = 120 - 120 * t; // baixo = verde, alto = vermelho
  return `background-color: hsla(${hue}, 65%, 42%, 0.55); color: #fff;`;
}

/** Menor e maior valor finito da grade; null se não houver nenhum. */
export function gridRange(grid: readonly (readonly number[])[]): { min: number; max: number } | null {
  let min = Infinity;
  let max = -Infinity;
  for (const row of grid) {
    for (const v of row) {
      if (!Number.isFinite(v)) continue;
      if (v < min) min = v;
      if (v > max) max = v;
    }
  }
  return Number.isFinite(min) ? { min, max } : null;
}
